export default {
	title: "Úroveň Vip",
	current: "Aktuálny VIP Stupeň",
	status: {
		btn: ["Aktivované", "Registrovať sa teraz"]
	}
};
